let getExchangeId = function (){
    if (document.getElementsByName('isKlaviyoEnabled').length && $(document.getElementsByName('isKlaviyoEnabled')[0]).val() === "true") {
    let klaviyoCookie = document.cookie.split("; ").filter(function(c) {return /__kla_id=/.test(c);});
    // Make sure cookie exists
    if (!Array.isArray(klaviyoCookie) && klaviyoCookie.length) { return "" }
    let klaviyoCookieData = JSON.parse(atob(klaviyoCookie[0].split("__kla_id=")[1]));
    // Make sure exchange ID exists
    if (!klaviyoCookieData["$exchange_id"]){ return "" }
    return klaviyoCookieData["$exchange_id"]
    }
}

function shouldAddParamsToLink(thisLink, listOfDomains){
    for (domainIdx in listOfDomains) {
        if( typeof thisLink !== 'undefined' &&
            typeof thisLink.href !== 'undefined' &&
            thisLink.href.indexOf(listOfDomains[domainIdx]) != -1){
            return true;
        }
    }
    return false;
}

function addKxToLinks(allDomains){
    let klaviyo = window.klaviyo || [];
    // Remove the current domain from the list
    let index = allDomains.indexOf(window.location.host);
    index !== -1 ? allDomains.splice(index, 1) : allDomains;
    // Make sure klaviyo is initialized
    if (typeof klaviyo !== 'undefined' && klaviyo != []){
        let exchange_token = getExchangeId()
        // Don't do anything unless the current browser is identified
        if (typeof exchange_token !== 'undefined' && exchange_token.length){
            document.querySelectorAll("a").forEach(function(node){
                if(shouldAddParamsToLink(node, allDomains)){
                    var href = node.href;
                    var param_connector = '?';
                    node.href = href + param_connector + '_kx=' + exchange_token;
                    // console.log(href +  " > " + node.href);
                }
            });
        }
    }
}

function getAllDomains() {
    var allDomains = [];
    if (document.getElementsByName('MSSCSiteInfo').length) {
        var MSSCSiteInfo = JSON.parse(document.getElementsByName('MSSCSiteInfo')[0].value);
    }

    if (typeof MSSCSiteInfo !== 'undefined' && Object.keys(MSSCSiteInfo).length > 0) {
        var i = 0;
        var length = Object.keys(MSSCSiteInfo).length;
        var keys = Object.keys(MSSCSiteInfo);

        while (i < length) {
            var site = MSSCSiteInfo[keys[i]];
            allDomains.push(site.fullurl);
            i++;
        }
    }

    return allDomains;
}

// Wait for the window to load then wait a bit longer for async JS to load
window.addEventListener('load', function(event){
    var allDomains = getAllDomains();
    setTimeout(() => {
        // Update these domains to match the root domains of your websites
        addKxToLinks(allDomains);
    }, 1000);
});